import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationWorkflowDeactivationFailedAction = {
	type: 'ORGANIZATION_WORKFLOW_DEACTIVATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): OrganizationWorkflowDeactivationFailedAction => ({
	type: 'ORGANIZATION_WORKFLOW_DEACTIVATION_FAILED',
	payload,
});
